module.exports = __webpack_public_path__ + "static/media/sound-waves.fc1e662f.svg";